import { get, put, post, upload } from '@api/request';

export async function fetchBPPPenaltyConfigurations(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyconfigurations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateBPPPenaltyConfiguration(
  { appraisalNoticeService },
  authenticationToken,
  { configID, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyconfiguration/${configID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchBPPPenaltyRuns(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyruns`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBPPPenaltyRun(
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addBPPPenaltyRun(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyruns`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchBPPPenaltyRunTypes(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyruntypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function captureBPPPenaltyPropertyData(
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/captureproperty`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchBPPPenaltyPropertyData(
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/propertylisting`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function processBPPPenaltyRun(
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/process`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function createBPPPenaltyRunExport(
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/export`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export const downloadBPPPenaltyRunExport = async (
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/export/downloadfile`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = penaltyID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const downloadBPPPenaltyFile = async (
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID, s3ID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = penaltyID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function uploadBPPPenaltyFile(
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function deleteBPPPenaltyFile(
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID, s3ID },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function editBPPPenaltyFile(
  { appraisalNoticeService },
  authenticationToken,
  { penaltyID, payload },
) {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/bpppenaltyrun/${penaltyID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
